import React from 'react';

const Footer = () => {
  return (
    <footer
      className="text-center py-4"
      style={{
        boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)', 
        position: 'relative',
        width: '100%',
     
        backdropFilter: 'blur(5px)', 
      }}
    >
      <div className="container">
        <p
          style={{
          
            fontWeight: '600',
            marginBottom: '0.5rem',
          }}
        >
          Copyright Pragyesh IAS 2023. All Rights Reserved​
        </p>
        <p
          style={{
            
            fontSize: '0.9rem',
            marginBottom: '0',
          }}
        >
          Empowering Innovation Through Education
        </p>
      </div>
    </footer>
  );
};

export default Footer;
